// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const BoxLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M3 17.1102V6.88997C3 6.65286 3.13964 6.43799 3.35632 6.34169L11.7563 2.60835C11.9115 2.5394 12.0885 2.5394 12.2437 2.60835L20.6437 6.34169C20.8604 6.43799 21 6.65286 21 6.88997V17.1102C21 17.3473 20.8604 17.5622 20.6437 17.6585L12.2437 21.3918C12.0885 21.4607 11.9115 21.4607 11.7563 21.3918L3.35632 17.6585C3.13964 17.5622 3 17.3473 3 17.1102Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.5 4.5L16.1437 8.34164C16.3604 8.43794 16.5 8.65281 16.5 8.88992V12.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21.3002 6.5L12.0002 10.84M12.0002 10.84L2.7002 6.5M12.0002 10.84V22" stroke={color} strokeWidth="2" />
    </svg>

);
